import React from 'react';
import { PetAttribute } from '../types';
import { ReactComponent as CloseIcon } from '@/assets/img/close-icon-new-v2.svg';
import './AssignedPetAttributeCard.scss';
type AssignedPetAttributeCardProps = {
  data: PetAttribute;
  onDelete: (petAttribute: PetAttribute) => void;
  isEditMode: boolean;
};

const AssignedPetAttributeCard = ({
  data,
  onDelete,
  isEditMode,
}: AssignedPetAttributeCardProps) => {
  const onDeleteClicked = () => {
    onDelete(data);
  };

  return (
    <div className="assigned-pet-attribute-card">
      <div className="left-section">
        {data.url.indexOf('http') >= 0 ? (
          <img className="attribute" src={data.url} alt="pet attribute" />
        ) : (
          <span className="emoji">{data.url}</span>
        )}
      </div>
      <div className="title-section-attribute">
        <p>{data.value}</p>
      </div>
      {isEditMode && <CloseIcon onClick={onDeleteClicked} />}
    </div>
  );
};

export default AssignedPetAttributeCard;
